<div class="hold-transition login-page">
    <div class="login-box">
      <div class="login-logo">
        <a href="./"><b>7t</b>Haven</a>
      </div>
      <!-- /.login-logo -->
      <div class="card">
        <div class="card-body login-card-body">
          <p class="login-box-msg">Sign in to start your session</p>
    
          <div [hidden]="!successMsg" [innerHTML]='success' class="alert alert-success text-center"></div>
          <div [hidden]="!errorMsg" [innerHTML]='error' class="alert alert-danger text-center"></div>
          <form [formGroup]="loginForm">
            <div class="input-group mb-3">
              <input type="email" formControlName="email" id="email" required [ngClass]="(email.invalid && (email.dirty || email.touched)) ? 'form-control is-invalid' : (email.valid)? 'form-control is-valid':'form-control'" autofocus placeholder="E-Mail">
              <div class="input-group-append">
                <div class="input-group-text">
                  <span class="fas fa-envelope"></span>
                </div>
              </div>
              <div *ngIf="email.invalid && (email.dirty || email.touched)" class="invalid-feedback">
                  <div *ngIf="email.errors.required">E-mail is required.</div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
              </div>
              <!-- /.col -->
              <div class="col-6">
                <button type="submit" [disabled]="!loginForm.valid || loginForm.pending || processing" (click)="onSubmit()" class="btn btn-primary btn-block">{{buttonText}}</button>
              </div>
              <!-- /.col -->
            </div>
          </form>
          <!-- /.social-auth-links -->
    
          <p class="mb-1">
            <a [routerLink]="['/login']">Login</a>
          </p>
        </div>
        <!-- /.login-card-body -->
      </div>
    </div>
    <!-- /.login-box -->
  </div>